"use client";

import { useState } from "react";
import './ContactForm.css';

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(() => {
    return localStorage.getItem("Submitted") === "true";
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting || isSubmitted) return;

    setIsSubmitting(true);

    try {
      const response = await fetch("https://api.explorelrt.com/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(form).toString(),
      });

      setForm({ name: "", email: "", message: "" });
      setIsSubmitted(true);
      localStorage.setItem("Submitted", "true");

      const result = await response.json();
      if (result.success) {
        setStatus(result.message);
      } else {
        setStatus(result.error);
      }

    } catch (error) {
      console.error("Error submitting feedback:", error);

    } finally {
      setIsSubmitting(false);
    }

  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="formContainer"
      >
        <div className="formSection">
          <label htmlFor="name">
            Name:
          </label>

          <input
            id="name"
            name="name"
            type="text"
            value={form.name}
            onChange={handleChange}
            placeholder="Full Name...."
          />

        </div>

        <div className="formSection">
          <label htmlFor="email">
            Email:
          </label>

          <input
            id="email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter your email..."
          />
        </div>

        <div className="formSection">
          <label htmlFor="message">
            Message:
          </label>

          <textarea
            id="message"
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Enter your message..."
          />
        </div>

        {status && (
          <p
            style={{
              marginTop: "1rem",
              color: status.startsWith("Your") ? "grey" : "red",
            }}
          >
            {status}
          </p>
        )}

        <button type="submit" className="formButton" disabled={isSubmitting || isSubmitted}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>

    </>
  );
}
